module.exports = __webpack_public_path__ + "img/tick.da632ce2.svg";